



/////////////////////////
//// SOME GLOBALS
/////////////////////////

// global scope
var fg = {};
// global vue-state
fg.state = Vue.observable({});
Vue.set(fg.state, 'active_stop_id', null);
// init global vue-mixins
Vue.mixin({
    data: function() { return { fg: { state: fg.state } } }
});





/////////////////////////
//// HERE IT STARTS
/////////////////////////
window.addEventListener("load", function(event) {

    // init map 
    fg.init_map();

    // get content
    fg.load_content();

});






/////////////////////////
//// init_map() - initialize the leaflet map
/////////////////////////
fg.init_map = function() {

    //// init map
    // create map
    fg.bounds = new L.LatLngBounds(new L.LatLng(48.669198799260045, 15.084228515625), new L.LatLng(48.079913949678364, 13.09295654296875));
    fg.map = L.map('fg_map', {
        maxZoom: 14,
        minZoom: 9,
        maxBounds: fg.bounds
    });
    // set init view
    fg.map.fitBounds(fg.bounds).setZoom(10);
    // add hand-drawn-map to map-canvas
    let imageUrl = 'karte.jpg?1';
    let imageBounds = [[48.669198799260045, 15.084228515625], [48.079913949678364, 13.09295654296875]];
    fg.imageOverlay = L.imageOverlay(imageUrl, imageBounds).addTo(fg.map);

    // add layergroup (for markers)
    //fg.map_markers_layer = L.layerGroup();
    fg.map_markers_layer = L.markerClusterGroup({
        spiderfyOnMaxZoom: true,
        showCoverageOnHover: false,
        zoomToBoundsOnClick: true,
        maxClusterRadius: 80
    });

    // L.marker([51.5, -0.09]).addTo(map)
    // .bindPopup('A pretty CSS3 popup.<br> Easily customizable.')
    // .openPopup();

};



/////////////////////////
//// load_content() - get content from server
/////////////////////////
fg.load_content = function(callback) {

    // make double ajax-call
    $.when(
        // AJAX #1 -> content.json
        $.ajax({
            url: 'https://wgd.fluxguide.com/fluxguide/public/content.json',
            timeout: 8000,
            cache: false,
            success: function(response) {
                fg.content = response.data;
            },
            error: function() {
                console.log('error. content.json could not be loaded');
            },
            dataType: 'json'
        }),
        // AJAX #2 -> content_stops.json
        $.ajax({
            url: 'https://wgd.fluxguide.com/fluxguide/public/content_stops.json',
            timeout: 8000,
            cache: false,
            success: function(response) {
                // stops
                fg.content_stops = response.data.stops[2];
                // categories
                fg.content_categories = fg.content.categories[2][1];
                fg.content_categories[0] = { id: "0", root_item_id: "0", title: "Alle Stops" };
            },
            error: function() {
                console.log('error. content_stops.json could not be loaded');
            },
            dataType: 'json'
        })
    )
        .then(
            // success -> content was downloaded
            function() {
                // draw map marker
                fg.draw_map_marker();
                // init vue app
                fg.init_vue_app();
            },
            // error -> content could not be loaded
            function() { console.log('Error. Data could not be loaded!') }
        );

};




/////////////////////////
//// draw_map_marker() - draw map marker on map
/////////////////////////
fg.draw_map_marker = function(category_id) {

    /// define stops that should be rendered
    // CASE - all stops
    if (category_id == 0 || category_id == undefined) var stops = fg.content_stops;
    // CASE - only a category
    else if (category_id > 0) {
        var stops = [];
        _.each(fg.content_stops, function(stop) {
            if (stop.categories.includes(category_id)) stops.push(stop);
        });
    }


    // remove previous map-markers
    fg.map_markers_layer.clearLayers();

    // loop all stops and draw marker
    _.each(stops, function(stop) {
        // no gps given -> exit
        if (stop.wgd_microsite_geoposition == "" || stop.wgd_microsite_geoposition == undefined) return;
        // get latlng
        var latlng = stop.wgd_microsite_geoposition.split(",");
        // draw marker
        var marker = L.marker(latlng);
        //// define marker-popup
        // var marker_popup = '<p class="map_marker_popup" onclick="fg.state.active_stop_id=' + stop.root_item_id + '">'; 
        var marker_popup = '<p class="map_marker_popup" onclick="fg.click_on_map_marker(' + stop.root_item_id + ')">';
        marker_popup += '<span class="map_marker_popup_title">' + stop.title + '</span> <br>';
        // "Details anzeigen" (für Detail-Popup)
        if (stop.audio_files.length != 0 || stop.description != "" || stop.description_more != "") marker_popup += '<span class="map_marker_popup_link">Details anzeigen</span>';
        // "Webseite öffnen" (für Link)
        else if (stop.wgd_microsite_url != "") marker_popup += '<span class="map_marker_popup_link">Webseite öffnen</span>';
        marker_popup += '</p>';
        marker.bindPopup(marker_popup).openPopup();
        // add to layer
        fg.map_markers_layer.addLayer(marker);
    });

    // add layer to map
    fg.map_markers_layer.addTo(fg.map);

};

/////////////////////////
//// click_on_map_marker(open_link) - event for map-marker-click
/////////////////////////
fg.click_on_map_marker = function(stop_id) {
    // get stop
    var stop = fg.content_stops[stop_id];
    // CASE - open detail-popup
    if (stop.audio_files.length != 0 || stop.description != "" || stop.description_more != "") fg.state.active_stop_id = stop_id;
    // CASE - open external link directly
    else if (stop.wgd_microsite_url != "") {
        window.open(stop.wgd_microsite_url, '_blank');
        window.focus();
    }
},



    /////////////////////////
    //// init_vue_app() - initialize our nice little vue app
    /////////////////////////
    fg.init_vue_app = function() {

        // init category-selector
        fg.vm_category = new Vue({
            id: 'category_selector',
            el: '#fg_vm_category',
            data: {
                categories: _.cloneDeep(fg.content_categories)
            },

            created() {

            },

            methods: {
                change_category(event) {
                    // get category-id
                    var category_id = _.clone(event.target.value);
                    // update map markers
                    fg.draw_map_marker(category_id);
                    // zoom out in map
                    fg.map.setZoom(10);
                }
            }
        });



        // init category-selector
        fg.vm_stop_overlay = new Vue({
            id: "stop_overlay",
            el: '#fg_vm_stop_overlay',
            data: {
                message: "HERE COMES THE STOP!!",
                categories: _.cloneDeep(fg.content_categories),
                base_url: 'https://wgd.fluxguide.com/fluxguide/'
            },
            computed: {
                stop: function() {
                    if (this.fg.state.active_stop_id > 0) {
                        return fg.content_stops[this.fg.state.active_stop_id];
                    }
                    else return false;
                },
                stop_image_gallery_url: function() {
                    if (this.fg.state.active_stop_id > 0 && fg.content_stops[this.fg.state.active_stop_id].image_gallery != "") {
                        return this.base_url + fg.content_stops[this.fg.state.active_stop_id].image_gallery;

                    }
                    else return false;
                },
                stop_audio_url: function() {
                    if (this.fg.state.active_stop_id > 0 && fg.content_stops[this.fg.state.active_stop_id].audio_files.length > 0) {
                        return this.base_url + fg.content_stops[this.fg.state.active_stop_id].audio_files[0].audio_url;
                    }
                    else return false;
                }
            },

            mounted() {

            },

            methods: {

            }

        });







    };


